import React from "react";
import { UserCheck, ClipboardList, Building2, Sparkles } from "lucide-react";

const AUDIENCES = [
  { icon: UserCheck, title: "Principals" },
  { icon: ClipboardList, title: "School secretaries" },
  { icon: Building2, title: "District buyers" },
  { icon: Sparkles, title: "Schools starting from scratch" },
];

export default function BundlesWho() {
  return (
    <section
      data-testid="bundles-who-section"
      className="bg-white py-24 md:py-32 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-14 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            Who this is for
          </div>
          <h2
            data-testid="bundles-who-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            Built for Schools That Want It{" "}
            <span className="text-teal">Done Right the First Time.</span>
          </h2>
        </div>

        <ul className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-5">
          {AUDIENCES.map((a, i) => {
            const Icon = a.icon;
            return (
              <li
                key={a.title}
                data-testid={`bundles-who-audience-${i}`}
                className="group flex flex-col items-start gap-4 bg-[#F4F6F4] hover:bg-white border border-slate-200 hover:border-teal/40 rounded-2xl p-6 sm:p-7 transition-all duration-300 hover:shadow-md hover:-translate-y-0.5"
              >
                <span className="flex-shrink-0 w-12 h-12 rounded-xl bg-navy text-white flex items-center justify-center group-hover:bg-teal transition-colors">
                  <Icon className="w-5 h-5" strokeWidth={2} />
                </span>
                <span className="font-serif text-base sm:text-lg font-bold text-navy leading-snug">
                  {a.title}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
